import { coreMessages, type AppLocale } from './base-messages';

export const zh: AppLocale = {
  ...coreMessages,
  dataTable: {
    rowModeLabel: 'Row display',
    rowModeEllipsis: 'Truncate (…)',
    rowModeScroll: 'Single line + horizontal scroll',
    rowModeWrap: 'Wrap lines',
    columnsLabel: 'Columns',
    reorderColumnHint: 'Drag the handle to move this column',
    resetThisTablePrefs: 'Reset this table',
    resetThisTablePrefsTitle: 'Clear saved layout for this table only (row mode, columns, order, widths). Does not change your global user settings.',
    dataOperationsLabel: '数据操作',
    operationExportExcel: '下载 Excel',
    operationDownloadTemplate: '下载模板',
    operationUploadTemplate: '上传模板',
    operationImportHistory: '导入历史',
    operationFieldDictionary: '字段字典',
    operationUnsupported: '此表不支持此操作。',
    operationNoPermission: '您没有此操作的权限。',
    operationNotReady: '此操作尚未准备就绪。',
    customFieldColumnsSectionLabel: '自定义字段',
    importModalTitle: '上传模板',
    importChooseFile: '选择 CSV 文件',
    importChooseFileHint: '填写并上传从此表下载的模板。',
    importNoFile: '未选择文件。',
    importSummary: '导入摘要',
    importReadyRows: '就绪行',
    importErrorRows: '错误行',
    importWarnings: '警告',
    importUnknownHeaders: '未知列',
    importMissingRequiredHeaders: '缺少必填列',
    importPreview: '预览',
    importSubmit: '开始导入',
    importCancel: '取消',
    importParsing: '正在读取文件...',
    importSubmitting: '正在导入...',
    importNoValidRows: '没有可导入的有效行。',
    importFailed: '导入失败。',
    importSucceeded: '导入完成。',
    operationExportCsv: '下载 CSV',
    operationExportPdf: '下载 PDF',
    operationNoRows: '没有可导出的可见行。',
    importUnknownHeader: '未知列：{header}',
    importMissingRequiredHeader: '缺少必填列：{header}',
    importRequiredCell: '{header} 为必填项。',
    importMaxRowsExceeded: '文件超过 {maxRows} 行；仅处理了前 {maxRows} 行。',
    refreshLabel: '刷新',
    focusModeEnterLabel: '聚焦表格',
    focusModeFullscreenLabel: '进入全屏',
    focusModeExitLabel: '退出表格聚焦',
    horizontalScrollLabel: '滚动表格列',
    selectionModeLabel: '选择行',
    selectAllRowsLabel: '选择所有行',
    selectRowLabel: '选择行',
    bulkSelectedLabel: '已选择 {count} 项',
    bulkActionsLabel: '批量操作',
    tableSettingsLabel: '表格设置',
    appearanceSectionLabel: '外观',
    columnsSectionLabel: '列',
    rowActionsLabel: '行操作',
  },
  passwordReset: {
    title: '设置新密码',
    description: '请选择一个只有您本人知道的高强度新密码。',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    passwordHelp: '至少使用 12 个字符，并至少包含以下三类：小写字母、大写字母、数字、特殊字符。',
    mismatch: '两次输入的密码不一致。',
    invalidLink: '密码重置链接缺失、无效或已过期。',
    submit: '更新密码',
    submitting: '正在更新密码...',
    success: '密码已更新。您现在可以使用新密码登录。',
    backToLogin: '返回登录',
    requestTitle: '发送密码重置链接',
    requestDescription: '一个有效期为 30 分钟的一次性链接将发送到用户的注册邮箱。在使用该链接前，当前密码不会更改。',
    requestSend: '发送链接',
    requestSending: '正在发送...',
    requestSuccess: '密码重置链接已进入发送流程。',
    requestError: '无法发送密码重置链接。',
    selfServiceOpen: '忘记密码',
    selfServiceTitle: '忘记密码',
    selfServiceDescription: '请输入企业账户电子邮件。若账户匹配，系统将发送一个有效期为 30 分钟的一次性链接。',
    selfServiceEmailLabel: '电子邮件',
    selfServiceSubmit: '请求链接',
    selfServiceSubmitting: '正在发送请求...',
    selfServiceAcknowledgement: '如果该电子邮件已注册，系统将发送密码重置链接。请检查收件箱和垃圾邮件。',
    selfServiceClose: '关闭',
    selfServiceCancel: '取消',
    selfServiceError: '目前无法完成密码重置请求，请稍后重试。',
    selfServiceRateLimited: '请求过多，请稍后重试。',
  },
  relationshipGraph: {
    sourceColumn: '来源',
    relationshipColumn: '关系',
    targetColumn: '关联记录',
    showDetails: '显示详情',
    hideDetails: '隐藏详情',
    controlsLabel: '地图控件',
    title: '关系图',
    diagramLabel: '记录关系',
    diagramHelp: '选择卡片以查看已保存的关联。',
    detailsTitle: '记录详情',
    connectionsTitle: '连接',
    noConnections: '没有连接',
    loading: '正在加载关系…',
    forbidden: '您无权查看这些关系。',
    error: '无法加载关系。请关闭后重试。',
    empty: '此记录没有可显示的关联。',
    invalid: '无法验证关系数据。请关闭后重试。',
    close: '关闭关系图',
    zoomIn: '放大',
    zoomOut: '缩小',
    fitView: '适应画布',
  },
  permissionPicker: {
    application: '应用',
    module: '模块',
    action: '操作',
    permissions: '权限',
    description: '描述',
    selection: '选择',
    sharedPermissions: '共享权限',
    selectedPermissions: '已选择 {count} 项权限',
    selectedOnly: '仅已选择',
    unselectedOnly: '仅未选择',
    selectedFirst: '已选择优先',
    noPermissions: '无权限',
  },
  errors: {
    ...coreMessages.errors,
    unknown: '发生未知错误',
    network: '无法连接到服务器。请检查您的网络连接。',
    timeout: '请求超时。请重试。',
    badRequest: '无效请求',
    unauthorized: '您的会话已过期。请重新登录。',
    forbidden: '您没有权限执行此操作。',
    notFound: '未找到请求的资源',
    tooManyRequests: '请求过于频繁。请稍后重试。',
    internalServerError: '服务器错误。请稍后重试。',
    badGateway: '服务器暂时不可用',
    serviceUnavailable: '服务暂时不可用',
    gatewayTimeout: '服务器无响应',
    serverErrorWithStatus: '服务器错误 ({status})',
  },
  common: {
    databaseUnavailableDeveloperHint: '开发者提示：在本地开发中，这通常表示 VPN 未开启或当前 IP 未被允许。请检查 VPN 和数据库访问权限。',
    ...coreMessages.common,
    requestTimeout: 'The request timed out. Please try again.',
    backendConnectionErrorDev: '无法连接到后端服务器。请确保服务器正在运行（{apiUrl}）。',
    backendConnectionErrorProd: '无法连接到后端服务器。请稍后重试。',
    systemUpdating: '系统更新中...',
    serverConfiguring: '服务器正在配置中，请稍候...',
    forbidden: 'Access denied.',
    network: 'Network error.',
    select: '选择',
    cancel: '取消',
    save: '保存',
    saving: '保存中...',
    edit: '编辑',
    view: '查看',
    copy: '复制',
    delete: '删除',
    appLauncher: '应用',
    allApps: '所有应用',
    loading: '加载中...',
    noData: '暂无数据',
    code: '代码',
    profileMenu: '个人资料菜单',
    selectLanguage: '选择语言',
    perPage: '每页',
    firstPage: '首页',
    previousPage: '上一页',
    nextPage: '下一页',
    lastPage: '末页',
    pleaseWait: '请稍候',
    migrationDescription: '正在应用数据库更新。此操作可能需要几秒钟。',
    changeText: '更改',
    deleteLogo: '删除标志',
    logoUploadHint: '最大文件大小：5MB。支持格式：JPEG、PNG、GIF、WebP',
    deleteAvatar: '删除头像',
    avatarUploadHint: '最大 5MB。JPEG、PNG、GIF、WebP。',
    newRecord: '新记录',
    noPermission: '无权限',
    searchPlaceholder: '搜索...',
    allStatuses: '全部状态',
    active: '启用',
    inactive: '停用',
    clearFilters: '清除筛选',
    all: '全部',
    clickToChangeStatus: '点击更改状态',
    noChangePermission: '您没有更改状态的权限',
    statusDistribution: '状态分布',
    hide: '隐藏',
    show: '显示',
    companies: 'Companies',
    adminConsole: '管理控制台',
    manageAccount: '管理您的账户',
    manageYourAccount: '管理您的账户',
    notificationsTitle: '通知',
    notificationsUnread: '未读',
    notificationsTypesMuted: '已静音类型',
    notificationsViewAll: '查看全部',
    notificationsPreferences: '偏好设置',
    notificationsMutedLabel: '已静音',
    notificationsEmpty: '没有通知',
    selectAll: '全选',
    id: '编号',
    remove: '移除',
    syncDeletedResult: '已删除 {count} 条孤立条目。',
    distributionByTable: '按表（上下文）分布',
    distributionByLocale: '按语言分布',
    translationReport: '翻译状态分布',
    page: '页',
    rows: '行',
    actions: '操作',
    create: '创建',
    search: '搜索',
    closeSearch: '关闭搜索',
    help: '帮助',
    helpCenter: '帮助中心',
    helpAboutPage: '关于此页面',
    helpDocumentation: '文档',
    helpKeyboardShortcuts: '键盘快捷键',
    helpWhatsNew: '新增功能',
    helpF1Hint: '按 F1 获取此页面的帮助',
    helpNoDocsForPage: '此页面的文档尚不可用',
    aiAssistantTitle: 'QubePro AI 助手',
    aiAssistantButton: 'AI 助手',
    aiAssistantUnavailable: 'AI 助手当前不可用。',
    appearancePreference: '外观偏好',
    modalControlPlacement: '表单控件布局',
    modalControlPlacementHint: '设置表单中关闭和全屏控件的位置。',
    modalControlPlacementSystem: '系统（推荐）',
    modalControlPlacementWindows: 'Windows',
    modalControlPlacementMacos: 'macOS',
    productTour: {
      start: '开始产品导览',
      restart: '重新开始产品导览',
      navigationTitle: '侧边栏和模块',
      navigationDescription: '使用侧边栏访问您有权使用的模块和页面，并展开或收起各个分区。',
      appsTitle: '应用',
      appsDescription: '从这里打开 QubePro 应用并在应用之间切换。',
      profileTitle: '个人资料和公司',
      profileDescription: '在这里管理个人资料、所选公司和语言偏好。',
      aiTitle: 'QubePro AI',
      aiDescription: '打开 QubePro AI 助手，获取与当前页面相关的帮助。',
      helpTitle: '帮助中心',
      helpDescription: '打开文档，或随时重新开始此产品导览。',
      next: '下一步',
      previous: '上一步',
      done: '完成',
      close: '关闭',
      neverShowAgain: '不再自动显示',
      progress: '{{current}} / {{total}}',
    },
    userExtensions: '扩展',
    close: '关闭',
    modalFocus: '聚焦表单',
    modalFullscreen: '进入全屏',
    modalRestore: '恢复大小',
    filterByColumn: '按{column}筛选',
    formCustomFieldsLoading: '正在加载自定义字段…',
    formCustomFieldsLoadError: '无法加载自定义字段。请在保存前重试，以免丢失数据。',
    formCustomFieldsRetry: '重试',
    pageUnavailableTitle: '无法打开页面',
    pageUnavailableMessage: '您可以从菜单打开其他页面，或刷新此页面。',
    pageReloadWarning: '刷新会丢失未保存的更改。',
    allTargetLanguages: '所有语言（10种语言）',
    darkMode: '深色模式',
    lightMode: '浅色模式',
    errorOccurred: '发生错误',
    confirm: '确认',
    context: '表',
    key: '列',
    originalShort: 'Orig.',
    originalValue: '原始值',
    locale: '语言',
    value: '值',
    status: '状态',
    auto: '自动',
    manual: '手动',
    manageLocales: '管理语言',
    updateUntranslatedFields: '同步新字段',
    autoTranslate: '自动翻译',
    sourceAndTargetMustDiffer: '源语言和目标语言必须不同。',
    autoTranslateSuccessCount: '已自动翻译 {count} 项。',
    syncEntriesResult: '已同步 {count} 条新翻译。',
    translated: 'Translated',
    missing: '缺失',
    autoTranslateScope: '自动翻译范围',
    updateUntranslatedFieldsHint: '点击"更新新字段"从这些表同步内容。',
    processing: '处理中...',
    enterTargetLanguage: '选择目标语言。',
    sourceLanguage: '源语言',
    selectLanguagesFirst: '请先在语言管理中选择语言',
    sourceLanguageLabel: '源语言（您的界面语言）',
    targetLanguage: '目标语言',
    activeLocalesDescription: '选择活动语言。仅保存为设置。',
    selectSourceLanguageForSync: '现有内容是什么语言？',
    languageNames: {
      en: '英语',
      tr: '土耳其语',
      de: '德语',
      fr: '法语',
      es: '西班牙语',
      ar: '阿拉伯语',
      it: '意大利语',
      ja: '日语',
      zh: '中文',
      ru: '俄语',
    },
    warning: '警告',
  },
  login: {
    ...coreMessages.login,
    loginFailed: '登录失败',
    emailRequired: '请输入邮箱地址',
    passwordRequired: '请输入密码',
    backendUnavailable: '服务器当前不可用。请稍后重试。',
    backendConnectFailed: '无法连接到服务器。请稍后重试。',
    backendConnectFailedDev: '无法连接到服务器。请确保服务器已启动 ({apiUrl})。',
    emailLabel: '邮箱',
    emailPlaceholderFull: '请输入您的电子邮箱',
    passwordLabel: '密码',
    passwordPlaceholderFull: '请输入密码',
    hidePassword: '隐藏密码',
    showPassword: '显示密码',
    loggingIn: '登录中...',
    submitButton: '登录',
    errors: {
      ...coreMessages.login.errors,
      invalidCredentials: '邮箱或密码错误，请重试。',
      sessionTooLarge: '会话数据过大。请重新登录。',
      databaseUnavailable: '数据库不可用或需要设置。请重新登录。',
      accountInactive: '您的账户未激活。请联系系统管理员。',
      sessionExpired: '会话已过期。请重新登录。',
      tooManyAttempts: '尝试次数过多。请稍后再试。',
    },
    featureTitle: "关联运营与财务记录",
    featureDescription: "使用 QubePro ERP 跟踪库存、采购、销售和财务记录。",
    featureCard1Title: "产品与库存",
    featureCard1Description: "管理产品、仓库和库存变动。",
    featureCard2Title: "采购",
    featureCard2Description: "跟踪采购单据和订单。",
    featureCard3Title: "销售单据",
    featureCard3Description: "管理销售订单和发票。",
    featureCard4Title: "财务变动",
    featureCard4Description: "查看银行、现金和财务记录。",
    darkMode: '深色模式',
    lightMode: '浅色模式',
    pleaseWait: '请稍候',
    serverConfiguring: '正在配置服务器，请稍候...',
    dbCreating: '正在创建数据库和所需配置。此过程可能需要几秒钟。',
    loginPageTitle: '登录',
    languageToggleLabel: '语言',
  },
  sidebar: {
    ...coreMessages.sidebar,
    dashboard: '仪表板',
    settings: '设置',
    toggleMenu: '打开菜单',
    toggleMenuClose: '关闭菜单',
    companies: '公司',
    logout: '退出登录',
    activityLogs: '活动日志',
  },
  customFields: {
    title: '自定义字段',
    newField: '新建自定义字段',
    editField: '编辑自定义字段',
    entityType: '记录类型',
    code: '字段代码',
    label: '显示名称',
    codePlaceholder: '例如: riskLevel',
    labelPlaceholder: '例如：特殊代码 1',
    dataType: '数据类型',
    type: '类型',
    scope: '范围',
    companyId: '公司 ID',
    companySelection: '公司',
    companySelectionPlaceholder: '留空为全局，或选择公司',
    selectedCompanies: '已选择 {{count}} 家公司',
    selectAllCompanies: '选择所有公司',
    sortOrder: '排序',
    required: '必填',
    searchable: '可搜索',
    showInForm: '在表单中显示',
    showInList: '显示列',
    formTab: '表单标签页',
    formTabSelect: '表单标签页',
    formTabPlaceholder: '留空则使用自定义字段标签页',
    defaultCustomTab: '自定义字段',
    selectEntityTypeFirst: '请先选择记录类型',
    newFormTab: '新标签页',
    tabCode: '标签页代码',
    tabName: '标签页名称',
    tabCodePlaceholder: '例如 operations',
    tabNamePlaceholder: '例如 运营信息',
    fieldWidth: '行布局',
    widthFull: '每行 1 个字段',
    widthHalf: '每行 2 个字段',
    widthThird: '每行 3 个字段',
    widthQuarter: '每行 4 个字段',
    systemField: '系统字段',
    description: '描述',
    options: '选项',
    optionsPlaceholder: '每行: code:标签\n示例: draft:草稿\n或只写草稿',
    defaultValue: '默认值',
    statusDistributionTitle: '{{title}} 状态分布',
    emptyMessage: '尚未定义自定义字段。',
    globalScope: '全局',
    companyScope: '公司 {{id}}',
    deleteSelected: '删除所选',
    deleteSelectedMessage: '将删除 {{count}} 个自定义字段。此操作无法撤销。',
    formDesigner: '表单设计',
    formDesignerTitle: '自定义字段表单设计',
    formDesignerEntityType: '要设计的记录类型',
    formDesignerAllTabs: '全部',
    formDesignerEmpty: '此记录类型没有自定义字段。',
    formDesignerOriginalNotice: '原始表单字段会保留；此页面用于管理自定义字段的标签页、顺序和行布局。',
    formDesignerSave: '保存设计',
    formDesignerSaved: '表单设计已保存。',
    formDesignerMoveUp: '上移',
    formDesignerMoveDown: '下移',
    formDesignerFieldSettings: '字段布局',
    formDesignerQuickSave: '保存',
    formDesignerEditTab: '编辑标签页',
    formDesignerDeleteTab: '删除标签页',
    formDesignerTabEditorTitle: '标签页设置',
    formDesignerCloseTabEditor: '关闭标签页编辑器',
    dataTypes: {
      text: '文本',
      number: '数字',
      date: '日期',
      datetime: '日期/时间',
      boolean: '是/否',
      select: '选择',
      json: 'JSON',
    },
  },
  activityLogs: {
    title: '活动日志',
    searchPlaceholder: '搜索（实体、模块、操作）…',
    allModules: '全部模块',
    allActions: '全部操作',
    allSeverity: '全部严重级别',
    allApps: '全部应用',
    startDate: '开始日期',
    endDate: '结束日期',
    exportCsv: '导出 CSV',
    total: '总计',
    today: '今天',
    critical: '严重',
    warning: '警告',
    severityInfo: '信息',
    exportFilenameStem: 'activity-logs',
    noLogs: '未找到活动日志。',   system: '系统',
    field: '字段',
    oldValue: '旧值',
    newValue: '新值',
    ip: 'IP',
    meta: '请求元数据',
    userAgent: 'User-Agent',
    entity: '实体',
    severityCol: '严重级别',
    userCol: '用户',
    actionCol: '操作',
    moduleCol: '模块',
    dateCol: '日期',
    appCol: '应用',
    overviewTitle: '概览',
    severityChart: '严重级别分布',
    topModulesChart: '按量排名靠前的模块',
    csvId: 'ID',
    csvDate: '日期',
    csvUser: '用户',
    csvAction: '操作',
    csvModule: '模块',
    csvEntity: '实体',
    csvSeverity: '严重级别',
    csvIp: 'IP',
    csvApplication: '应用',
    companyCol: '公司 ID',
    allOutcomes: '全部结果',
    noLogsDesc: '用户执行操作后，日志将显示在此处。',
    entityType: '记录类型',
    actorType: '操作者类型',
    outcome: '结果',
    successful: '成功',
    failed: '失败',
    denied: '已拒绝',
    reason: '原因',
    requestId: '请求 ID',
    correlationId: '关联 ID',
    integrity: '完整性证明',
    outboxWarning: '审计投递队列需要处理。',
  },

  // Header Notifications page
  headerNotifications: {
    tabNotifications: '通知',
    tabPreferences: '偏好设置',
    markAllRead: '全部标为已读',
    notifCount: '{total} 条通知',
    unreadCount: '{count} 条未读',
    loading: '正在加载通知...',
    noNotifications: '没有通知',    markRead: '标为已读',
    delete: '删除',   noPreferences: '没有偏好设置',
    noPreferencesDesc: '尚未发现通知类别。收到通知时将自动创建偏好设置。',
    preferencesHeader: '应用内通知偏好',
    prefItemDesc: '在应用内接收此类别的通知',
    readDistribution: '阅读状态分布',
    readStatusLabel: '阅读状态',
    filterAll: '全部',
    filterUnread: '未读',
    filterRead: '已读',    colType: '类型',
    colTitle: '标题',
    colMessage: '消息',
    colDate: '日期',
    colRead: '状态',
    statusUnread: '未读',
    statusRead: '已读',
    searchNotifications: '搜索标题或消息…',
  },
};
